import { render, staticRenderFns } from "./PlaceholderTitleTextFormInput.vue?vue&type=template&id=5b01fca0&scoped=true&"
import script from "./PlaceholderTitleTextFormInput.vue?vue&type=script&lang=ts&"
export * from "./PlaceholderTitleTextFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./PlaceholderTitleTextFormInput.vue?vue&type=style&index=0&id=5b01fca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01fca0",
  null
  
)

export default component.exports